import { connect } from "react-redux"
import { Dispatch } from "redux"
import { getCurrentUser } from "../../libs/get-current-user"
import { RootState, ReduxAction } from "../../reducers"
import { Channel } from "../../rpcs/dist/ChannelRPC"
import { Episode } from "../../rpcs/dist/EpisodeRPC"
import { User } from "../../rpcs/dist/UserRPC"
import { ActionDispatcher } from "./actiondispacher/action-dispacher"

export interface IContainerProps {
  actions: ActionDispatcher
  episode: Episode | null
  channels: Channel[] | null
  currentUser: User | null
}

const mapStateToProps = ({
  pages,
  switchingUser,
  loginData,
}: RootState): Omit<IContainerProps, "actions"> => ({
  episode: pages.editor.fetchData.episode,
  channels: pages.editor.fetchData.channels,
  currentUser: getCurrentUser(loginData, switchingUser),
})

const mapDispatchToProps = (dispatch: Dispatch<ReduxAction>) => ({
  actions: new ActionDispatcher(dispatch),
})

export const container = connect(mapStateToProps, mapDispatchToProps)
